import * as React from 'react';

export const arrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="16"
    viewBox="0 0 27 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.4776 15.2071C19.6965 15.9881 18.4302 15.9881 17.6491 15.2071L17.5962 15.1542C16.8152 14.3731 16.8152 13.1068 17.5962 12.3258L19.8847 10.0373L2.80003 10.0373C1.69546 10.0373 0.800026 9.1419 0.800026 8.03733V7.96255C0.800026 6.85798 1.69546 5.96255 2.80003 5.96255L19.8696 5.96255L17.5662 3.65907C16.7851 2.87803 16.7851 1.61169 17.5661 0.830646L17.604 0.792818C18.385 0.0117694 19.6514 0.0117688 20.4324 0.792817L26.195 6.55543L26.2479 6.60831C27.0289 7.38935 27.0289 8.65568 26.2479 9.43673L26.2101 9.47456L20.4776 15.2071Z"
      fill="#F6B533"
    />
  </svg>
);
